import { Plans, PriceTable } from 'components/account/StoreDetails/PriceTable';

export const PricingStep = () => {
  const plans: Plans = [
    {
      id: 2,
      label: 'Small business',
      name: 'small',
      price: 79,
      description: [
        'Best for new businesses building out your niche',
        'Pre $1m USD annual revenue',
        'Under 50k customers',
      ],
      features: [
        '1 year of data analysis',
        '5,000 customers per sync',
        '2 team members',
        'Email and Facebook integration',
      ],
      featured: false,
    },
    {
      id: 1,
      label: 'Growth',
      name: 'growth',
      price: 239,
      description: [
        'Best for growing businesses looking for more insights',
        'Above $1m USD annual revenue',
        'Above 50k customers',
      ],
      features: [
        '2 years of data analysis',
        '25,000 customers per sync',
        '5 team members',
        'Email and Facebook integration',
        'Advanced product analytics',
      ],
      featured: true,
    },
    {
      id: 0,
      label: 'Unlimited',
      name: 'unlimited',
      price: 849,
      description: [
        'Best for high volume merchants and large businesses',
        'Above $5m USD annual revenue',
        'Above 100k customers',
      ],
      features: [
        'Unlimited data analysis',
        'Unlimited customers per sync',
        '20 team members',
        'Email and Facebook integration',
        'Advanced product analytics',
        'Priority support',
      ],
      featured: false,
    },
  ];

  return (
    <div className="lg:my-16 lg:mx-32">
      <div className="flex items-center p-5 space-x-2 lg:p-0">
        <img
          width="40"
          height="40"
          src="/assets/logo-segments.png"
          alt="logo"
          className="w-6 h-6 lg:h-10 lg:w-10"
        />
        <p className="text-base lg:hidden lg:p-0 lg:text-2xl tracking-segments-logo text-segments-dark">
          Segments
        </p>
      </div>
      <div className="px-5 mx-auto mt-6 lg:px-0">
        <p className="font-bold leading-6 text-[28px]">Plan and pricing</p>

        <p className="mt-2 text-base">
          Enjoy your 14-day trial with no commitment! You can change to any plan
          anytime.
        </p>

        <div className="mt-6 space-y-1.5">
          <div className="flex items-center space-x-1">
            <CheckIcon />
            <p>Powerful analytics and pre-built segmentation</p>
          </div>
          <div className="flex items-center space-x-1">
            <CheckIcon />
            <p>Online and email support</p>
          </div>
          <div className="flex items-center space-x-1">
            <CheckIcon />
            <p>Upgrade or switch to free plan anytime</p>
          </div>
        </div>
        <PriceTable plans={plans} />
      </div>
    </div>
  );
};

function CheckIcon() {
  return (
    <svg width="21" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 10c0-4.14-3.36-7.5-7.5-7.5C6.36 2.5 3 5.86 3 10c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5Z"
        stroke="#54B363"
        strokeMiterlimit="10"
      />
      <path
        d="M14.25 6.875 9 13.125l-2.25-2.5"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
